export default typeof window === "undefined" ? "server" : "browser";
